import { DateMath } from "../../../date/DateMath";
import { ClassFlag } from "../../../dom-tools/ClassFlag";
import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { DateParser } from "../../../date/DateParser";

export abstract class Filter
{
  static readonly setting  = new ElementAttribute( "-filter--setting" );
  static readonly selector = new ElementAttribute( "-selector" );
  static readonly root     = new ElementAttribute( "-root" );
  static readonly group    = new ElementAttribute( "-group" );

  protected abstract _filterElement( e:Element ):boolean;
  filterElement( e:Element ):boolean 
  {
    return this.enabled ? ( this._filterElement( e ) ) : true; 
  }

  filterSettings:Element;
  selector:string;
  useRoot:boolean = false;
  enabled:boolean = true;
  group:string = null;

  constructor( filterSettings:Element )
  {
    if ( ! filterSettings )
    {
      return;
    }
  
    this.filterSettings = filterSettings;
    this.selector = Filter.selector.from( filterSettings );
    this.group = Filter.group.from( filterSettings );
    this.useRoot = Filter.root.in( filterSettings );
  }

  getElement( e:Element )
  {
    if ( this.useRoot )
    {
      return e;
    }

    return e.querySelector( this.selector );
  } 



  static isFiltered( e:Element, filters:Filter[] )
  {
    for ( let f of filters )
    {
      if ( ! f.filterElement( e ) )
      {
        return false; 
      }
    }

    return true;
  }
}

